import {
  CREATE_COMPLETED_UNIT_COMMAND,
  DELETE_COMPLETED_UNIT_COMMAND,
  EDIT_COMPLETED_UNIT_COMMAND,
  RECEIVE_COMPLETED_UNIT_COMMANDS,
  REQUEST_ALL_UNIT_COMMANDS_FOR_SITE_WITH_RANGE,
  REQUEST_COMPLETED_UNIT_COMMAND,
  REQUEST_RECENT_COMPLETED_UNIT_COMMANDS_FOR_SITE,
} from '@sophocles/entities/CompletedUnitCommand/completedUnitCommandActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_COMPLETED_UNIT_COMMANDS: // Read
      return state.merge(action.completedUnitCommands);
    case DELETE_COMPLETED_UNIT_COMMAND: // Delete
      return state.delete(action.completedUnitCommand.toString());
    case EDIT_COMPLETED_UNIT_COMMAND: // Update
    case CREATE_COMPLETED_UNIT_COMMAND: // Create
    case REQUEST_COMPLETED_UNIT_COMMAND:
    case REQUEST_RECENT_COMPLETED_UNIT_COMMANDS_FOR_SITE:
    case REQUEST_ALL_UNIT_COMMANDS_FOR_SITE_WITH_RANGE:
    default:
      return state;
  }
}

export function completedUnitCommandReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_COMPLETED_UNIT_COMMAND:
    case DELETE_COMPLETED_UNIT_COMMAND:
    case RECEIVE_COMPLETED_UNIT_COMMANDS:
    case EDIT_COMPLETED_UNIT_COMMAND:
    case REQUEST_COMPLETED_UNIT_COMMAND:
    case REQUEST_RECENT_COMPLETED_UNIT_COMMANDS_FOR_SITE:
    case REQUEST_ALL_UNIT_COMMANDS_FOR_SITE_WITH_RANGE:
      return getState(state, action);
    default:
      return state;
  }
}
